import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAcceptGuidanceValue, IReportTemplateSection } from '@shared/interfaces';
import { ReportBuilderService } from '@app/main/report/services/report-builder.service';
import { ReportService } from '@shared/services/report.service';

@Component({
    selector: 'app-report-section-guidance',
    templateUrl: './report-section-guidance.component.html',
    styleUrls: ['./report-section-guidance.component.scss'],
    standalone: false
})
export class ReportSectionGuidanceComponent {
    constructor(
        public dialogRef: MatDialogRef<ReportSectionGuidanceComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { section: IReportTemplateSection },
        private reportService: ReportService,
        public builder: ReportBuilderService
    ) {}

    get guidance(): string {
        return this.builder.reportLanguage === 'de' && this.data.section.guidance.contentDe
            ? this.data.section.guidance.contentDe
            : this.data.section.guidance.content;
    }

    get isDe() {
        return this.builder.reportLanguage === 'de';
    }

    get guidanceValue(): boolean {
        return this.builder.report ? this.builder.report.guidanceValues[this.data.section.guidance.id] : null;
    }

    get sectionTitle(): string {
        return this.builder.reportLanguage === 'de' && this.data.section.titleDe
            ? this.data.section.titleDe
            : this.data.section.title;
    }

    get showAcceptance(): boolean {
        return this.builder.isAbleToEditAsSpecialist;
    }

    protected async acceptGuidance(close?: boolean): Promise<void> {
        if (!this.builder.isAbleToEditAsSpecialist) {
            return;
        }

        const item: IAcceptGuidanceValue = {
            id: this.builder.report.id,
            guidanceValues: {
                ...this.builder.report.guidanceValues,
                [this.data.section.guidance.id]: true
            },
            reportValues: this.builder.report.reportValues
        };

        try {
            this.builder.report.guidanceValues[this.data.section.guidance.id] = true;
            await this.reportService.updateGuidance(item);
            if (close) {
                this.dialogRef.close(this.guidance);
            }
        } catch (error) {
            console.error(error);
        }
    }

    protected close(): void {
        this.dialogRef.close(this.data);
    }
}
